import { useMemo } from 'react';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import { FilterNames, getFiltersData } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export const useLogicCheckerFilterHook = () => {
    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);

    const fetchFiltersDataObj = {
        [FilterNames.ACTIVITY_CODES]: globalFilterData?.activityCodes
            ?.filter((item) => !item.isExclude)
            .map((i) => i.name),
        [FilterNames.ACTIVITY_CODES_EXCLUDE]: globalFilterData?.activityCodes
            ?.filter((item) => item.isExclude)
            .map((i) => i.name),
        [FilterNames.FRAGNET_SEARCH]: globalFilterData?.milestoneFragnet,
        [FilterNames.TAG_CARD_BOARD]: globalFilterData?.tags?.filter((item) => !item.isExclude).map((i) => i.name),
        [FilterNames.TAG_CARD_BOARD_EXCLUDE]: globalFilterData?.tags
            ?.filter((item) => item.isExclude)
            .map((i) => i.name),
        [FilterNames.WBS_SEARCH]: globalFilterData?.wbs,
    };
    return useMemo(() => getFiltersData(fetchFiltersDataObj), [globalFilterData]);
};
